import {createBrowserApp} from '@react-navigation/web';
import {customNavigator} from '../../navigators/custom.navigator';

const App = createBrowserApp(customNavigator);

export default App;
